var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "group-members-page" },
    [
      _c("group-page-header", { attrs: { title: "All Members" } }, [
        _vm.viewer_state.is_admin
          ? _c(
              "span",
              {
                attrs: { slot: "additionalButtons" },
                slot: "additionalButtons",
              },
              [
                _c("toggle-edit-mode-button", {
                  model: {
                    value: _vm.editMode,
                    callback: function ($$v) {
                      _vm.editMode = $$v
                    },
                    expression: "editMode",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", {}, [
        _vm.admins.length
          ? _c("span", { staticClass: "group-page-header" }, [
              _vm._v("Group Admins\n            "),
              _vm.viewer_state.is_admin && _vm.editMode
                ? _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Manage Admins",
                        expression: "'Manage Admins'",
                      },
                    ],
                    staticClass: "fa fa-pencil pointer",
                    attrs: {
                      "aria-label": "Manage Admins",
                      tabindex: "0",
                      role: "button",
                    },
                    on: {
                      click: _vm.manageAdmins,
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.manageAdmins.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.admins.length
        ? _c(
            "div",
            { staticClass: "group-members-page__members-container" },
            [
              _vm._l(_vm.admins, function (admin) {
                return _c(
                  "a",
                  {
                    key: admin.id,
                    staticClass: "hvr-float-shadow margin-30-bottom",
                    attrs: { href: admin.link },
                  },
                  [
                    _c("vue-stuff-preview", {
                      attrs: {
                        "stuff-type": "user",
                        "stuff-item": admin,
                        "online-mark": admin.online,
                        animation: false,
                        size: _vm.swamItemSize,
                        margin: 0,
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(
                _vm.swamGetFakeItems(_vm.admins.length),
                function (fakeItem) {
                  return _c("div", {
                    key: fakeItem.id,
                    style: _vm.swamFakeIconStyle,
                  })
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && !_vm.allAdminsLoaded
        ? _c("div", { staticClass: "text-center" }, [
            _c(
              "span",
              {
                staticClass: "pointer group-members-page__load-more-button",
                attrs: {
                  tabindex: "0",
                  "aria-label": "Load More",
                  role: "button",
                },
                on: {
                  click: _vm.loadMoreAdmins,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.loadMoreAdmins.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "Load " +
                    _vm._s(this.totalAdminsCount - this.admins.length) +
                    " more"
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {}, [
        _vm.members.length
          ? _c("span", { staticClass: "group-page-header" }, [
              _vm._v("Group Members\n            "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.members.length
        ? _c(
            "div",
            { staticClass: "group-members-page__members-container" },
            [
              _vm._l(_vm.members, function (member) {
                return _c(
                  "a",
                  {
                    key: member.id,
                    staticClass: "hvr-float-shadow margin-30-bottom",
                    attrs: { href: member.link },
                  },
                  [
                    _c("vue-stuff-preview", {
                      attrs: {
                        "stuff-type": "user",
                        "stuff-item": member,
                        "online-mark": member.online,
                        animation: false,
                        size: _vm.swamItemSize,
                        deletable: _vm.editMode,
                        margin: 0,
                      },
                      on: {
                        delete: function ($event) {
                          return _vm.deleteMember(member)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(
                _vm.swamGetFakeItems(_vm.members.length),
                function (fakeItem) {
                  return _c("div", {
                    key: fakeItem.id,
                    style: _vm.swamFakeIconStyle,
                  })
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.loadMore,
            expression: "loadMore",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }